import React from "react";
import Layout from "../../reusables/layout/layout";
import RegisterFormBeceCas from "../../Component/registerform/registerBeceCas";


const PaymentRegisterBece = () => {

  return (
    <div>
      <Layout>
        <RegisterFormBeceCas 
        examType={'BECE EXAMINATION'}
        serviceType={'bece'}
        navigateTo={'/bece/payment/login'}
        homeLink={"https://bece.examsboard.lagosstate.gov.ng/"}
         />
      </Layout>
    </div>
  );
};


export default PaymentRegisterBece;
